<template>
    <b-form-group
        :description="this.$t('editFields')"
        :label="this.$t('fields')"
        label-for="perPage"
        :label-cols="2"
        :horizontal="true">
        <div class="form-actions">
            <helptip
            helpType="icon"
            tipId="component.settings.list.fields"
            >
                <b-button type="submit" variant="primary" @click="editor.show = true">{{ $t('edit') }}</b-button>
            </helptip>
        </div>
        <b-modal title="Edit fields in list" v-model="editor.show">
            <b-list-group>
                <b-list-group-item
                v-for="field in appendedFields"
                button
                :variant="buttonVariant(field)"
                v-bind:key="field.key"
                @click="fieldEditorShow(field)"
                >
                    {{ field.name }}
                </b-list-group-item>
            </b-list-group>

            <b-modal :title="fieldEditor.title" v-model="fieldEditor.show" @ok="fieldEditorSave" @cancel="fieldEditorCancel" cancel-title="Remove" cancel-variant="danger">
                <b-form-group
                    :label="this.$t('label')"
                    label-for="label"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="text" v-model="fieldEditor.field.name"></b-form-input>
                </b-form-group>
                <b-form-group
                    :label="this.$t('sortOrder')"
                    label-for="sortOrder"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-input type="number" v-model.number="fieldEditor.field.sortOrder"></b-form-input>
                </b-form-group>
                 <b-form-group
                    :label="this.$t('variant')"
                    label-for="variant"
                    :label-cols="3"
                    :horizontal="false">
                    <b-form-select id="variant"
                    :plain="false"
                    :options="variants"
                    v-model="fieldEditor.field.variant">
                  </b-form-select>
                </b-form-group>
                <b-form-group
                    :label="this.$t('sortable')"
                    label-for="sortable"
                    :label-cols="3"
                    :horizontal="false">
                <c-switch class="mx-1" color="success" variant="pill" v-model="fieldEditor.field.sortable"/>
                </b-form-group>
                <b-form-group
                    :label="this.$t('filterable')"
                    label-for="filterable"
                    :label-cols="3"
                    :horizontal="false">
                <c-switch class="mx-1" color="success" variant="pill" v-model="fieldEditor.field.filterable"/>
                </b-form-group>
                <b-form-group
                    :label="this.$t('formatter')"
                    label-for="formatter"
                    :label-cols="3"
                    :horizontal="false"
                    v-if="showFormatter()"
                    >
                    <div class="form-actions">
                        <b-button id="editFieldsButton" type="submit" variant="success" @click="formatterEditor.show = true">{{ $t('openEditor') }}</b-button>
                    </div>
                    <b-modal size="lg" title="Formatter editor" v-model="formatterEditor.show">
                        <codemirror v-model="fieldEditor.field.formatterEditor" :options="formatterEditor.options"></codemirror>
                    </b-modal>
                </b-form-group>
            </b-modal>
        </b-modal>
    </b-form-group>
</template>
<script>
import { Switch as cSwitch } from '@coreui/vue'
import { deepCopyObject } from "../../../shared/utils"
// require component
import { codemirror } from 'vue-codemirror'
import 'codemirror/lib/codemirror.css'
import 'codemirror/addon/display/autorefresh.js'

// elements
import Helptip from '../../elements/Helptip.vue'

export default {
    components: {
        cSwitch,
        codemirror,
        Helptip
    },
    props: {
        settings: {
            type: Object
        },
        list: {
            type: Object
        },
        value: {
            type: Array,
            default: []
        }
    },
    data: function() {
        return {
            variants:  [
                'primary',
                'secondary',
                'info',
                'danger',
                'warning',
                'success',
                'light',
                'dark'
            ],
            editor: {
                show: false
            },
            fieldEditor: {
                show: false,
                title: "",
                field: {
                    name: "",
                    key: "",
                    sortable: false,
                    sortDirection: "asc",
                    sortByFormatted: false,
                    filterByFormatted: false,
                    formatterEditor: "",
                    variant: ""
                }
            },
            formatterEditor: {
                show: false,
                formatter: "",
                options: {
                    tabSize: 4,
                    lineNumbers: true,
                    line: true,
                    autoRefresh: true,
                    foldGutter: true,
                    styleSelectedText: true,
                    mode: 'text/javascript',
                    matchBrackets: true,
                    showCursorWhenSelecting: true
                }
            }
        }
    },
    computed: {
        fieldsListed() {
            if (this.value === null) {
                return []
            }

            return this.value
        },

        appendedFields() {
            let fields = deepCopyObject(this.settings.fields) || []

            fields.unshift({
                name: "UUID",
                key: "uuid"

            })

            if (this.settings.model.disable) {
                fields.push({
                    name: "Disabled at",
                    key: "disabled_at"
                })
            }

            if (this.settings.model.timestamps) {
                fields.push({
                    name: "Created at",
                    key: "created_at"
                })

                fields.push({
                    name: "Updated at",
                    key: "updated_at"
                })
            }

            return fields;
        }
    },
    methods: {
        isListed(field) {
            return this.fieldsListed.find(item => {
                return item.key == field.key
            })
        },

        buttonVariant(field) {
            if (this.isListed(field)) {
                return "success"
            }

            return null
        },

        fieldEditorShow(field) {
            this.fieldEditor.show = true
            this.fieldEditor.title = field.name
            this.fieldEditor.field = this.isListed(field)

            if (this.fieldEditor.field === undefined) {
                this.fieldEditor.field = {
                    label: field.name,
                    key: field.key,
                    sortable: false,
                    sortDirection: 'asc',
                    variant: '',
                    sortByFormatted: false,
                    filterByFormatted: false,
                    formatterEditor: ""
                }
            }
        },

        fieldEditorSave() {
            let currentField = this.fieldEditor.field

            if (!this.isListed(currentField)) {
                this.fieldsListed.push(currentField)
            }

            this.$emit("input", this.fieldsListed)
        },

        fieldEditorCancel() {
            let currentField = this.fieldEditor.field

            let fields = this.fieldsListed.filter(f => {
                return f.key != currentField.key
            })

            this.$emit("input", fields)
        },

        showFormatter() {
            let key = this.fieldEditor.field.key
            if (this.settings.fields !== null) {
                let field = this.settings.fields.find(f => {
                    return f.key == key
                })

                if (field !== undefined) {
                    if (field.module == 'input' && field.type == 'image') {
                        return false;
                    }

                }
            }

            return true;
        }
    }
}
</script>
